const timeToNumber = (time: string) => {
  if (time === '') {
    return 0
  }
  if (time === '23:59') {
    return 48
  }
  const [hour, minute] = time.split(':')
  return Number(hour) * 2 + Number(minute) / 30
}

export default timeToNumber
